import { mapToTargetForm } from "./notificationDataMapper";

export const useNotificationAccept = ({
  reset,
  setModalOpen,
  setModalDefaultValues,
  transform,
}) => {
  let notificationId = null; // Store notificationId internally

  const handleAccept = (notification, sourceData) => {
    if (!notification || !sourceData) return;

    let mappedData = mapToTargetForm(sourceData, notification);

    let finalData = transform
      ? transform({ ...mappedData })
      : { ...mappedData };

    notificationId = notification.id; // Store the notificationId
    finalData.notificationId = notification.id;

    const formData = { ...finalData };

    // update form correctly
    reset(formData);

    // optional UI state
    if (setModalDefaultValues) {
      setModalDefaultValues(formData);
    }

    // open modal AFTER data ready
    setModalOpen(true);
  };

  // Function to add notificationId to submit data
  const addNotificationId = (data) => {
    if (notificationId) {
      data.notificationId = notificationId;
    }
    return data;
  };

  return { handleAccept, addNotificationId };
};
